module.exports = __webpack_public_path__ + "img/activities-20.8f8510e8.jpg";